"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./subscription"));
__export(require("./transactions"));
const __1 = require("..");
var AccountType;
(function (AccountType) {
    AccountType["INDIVIDUAL"] = "Individual";
    AccountType["BUSINESS"] = "Organization";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
/**
 * Custom field on the CIMA Zuora Payment Method object that stores the name of the gateway
 * used by the Hosted Payment Page when a saved CIMA credit card was created.
 */
exports.CIMA_ORIGINAL_PAYMENT_GATEWAY_FIELD = 'OriginalPaymentGateway__c';
var CimaPaymentGatewayErrorCode;
(function (CimaPaymentGatewayErrorCode) {
    CimaPaymentGatewayErrorCode["INVALID_GATEWAY_ATTEMPT"] = "INVALID_GATEWAY_ATTEMPT";
    CimaPaymentGatewayErrorCode["GATEWAY_CONFIGURATION_MISSING"] = "GATEWAY_CONFIGURATION_MISSING";
    CimaPaymentGatewayErrorCode["FIELD_CONFIGURATION_MISSING"] = "FIELD_CONFIGURATION_MISSING";
    CimaPaymentGatewayErrorCode["RETRIEVAL_FAILED"] = "RETRIEVAL_FAILED";
    CimaPaymentGatewayErrorCode["PAYMENT_METHOD_NOT_FOUND"] = "PAYMENT_METHOD_NOT_FOUND";
    CimaPaymentGatewayErrorCode["UNAUTHORIZED_ACCOUNT"] = "UNAUTHORIZED_ACCOUNT";
    CimaPaymentGatewayErrorCode["OWNERSHIP_MISMATCH"] = "OWNERSHIP_MISMATCH";
    // the payment method is not yet attached to any Account (a first-time customer's HPM card before
    // the order collects payment with it), so ownership cannot be established yet
    CimaPaymentGatewayErrorCode["PAYMENT_METHOD_NOT_ATTACHED"] = "PAYMENT_METHOD_NOT_ATTACHED";
    CimaPaymentGatewayErrorCode["NOT_CREDIT_CARD"] = "NOT_CREDIT_CARD";
    CimaPaymentGatewayErrorCode["INELIGIBLE_PAYMENT_METHOD"] = "INELIGIBLE_PAYMENT_METHOD";
    CimaPaymentGatewayErrorCode["METADATA_CONFLICT"] = "METADATA_CONFLICT";
    CimaPaymentGatewayErrorCode["PERSISTENCE_FAILED"] = "PERSISTENCE_FAILED";
    CimaPaymentGatewayErrorCode["ACCOUNT_UPDATE_FAILED"] = "ACCOUNT_UPDATE_FAILED";
})(CimaPaymentGatewayErrorCode = exports.CimaPaymentGatewayErrorCode || (exports.CimaPaymentGatewayErrorCode = {}));
var LegalEntity;
(function (LegalEntity) {
    LegalEntity["ASSOCIATION"] = "association";
    LegalEntity["CIMA"] = "cima";
})(LegalEntity = exports.LegalEntity || (exports.LegalEntity = {}));
var EntityName;
(function (EntityName) {
    EntityName["UK_CIMA"] = "UK - CIMA";
    EntityName["US_AICPA"] = "US - AICPA";
})(EntityName = exports.EntityName || (exports.EntityName = {}));
var EntityMigrationConstant;
(function (EntityMigrationConstant) {
    EntityMigrationConstant["value"] = "_1";
})(EntityMigrationConstant = exports.EntityMigrationConstant || (exports.EntityMigrationConstant = {}));
exports.LegalEntityNameMap = {
    [EntityName.UK_CIMA]: LegalEntity.CIMA,
    [EntityName.US_AICPA]: LegalEntity.ASSOCIATION,
};
exports.MembershipBodyLegalEntityMap = {
    [LegalEntity.CIMA]: __1.Product.ProductMembershipBody.CIMA,
    [LegalEntity.ASSOCIATION]: __1.Product.ProductMembershipBody.AICPA,
};
var InvoiceItemProcessingType;
(function (InvoiceItemProcessingType) {
    InvoiceItemProcessingType[InvoiceItemProcessingType["CHARGE"] = 0] = "CHARGE";
    InvoiceItemProcessingType[InvoiceItemProcessingType["DISCOUNT"] = 1] = "DISCOUNT";
    InvoiceItemProcessingType[InvoiceItemProcessingType["PREPAYMENT"] = 2] = "PREPAYMENT";
    InvoiceItemProcessingType[InvoiceItemProcessingType["TAX"] = 3] = "TAX";
})(InvoiceItemProcessingType = exports.InvoiceItemProcessingType || (exports.InvoiceItemProcessingType = {}));
var OrderType;
(function (OrderType) {
    OrderType["DONATION"] = "donation";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
//# sourceMappingURL=index.js.map